import { gql } from '__generated__';

export default gql(`
  query GetInvoicesReport($project: ID!) {
    project(id: $project) {
      id
      invoices {
        id
        invoice_id
        start_date
        gross_amount
        organisation
      }
    }
  }
`);
